<template>
  <el-row :gutter="24" type="flex">
    <el-col :span="2" class="flight-item">
      <el-col>
        <el-checkbox :label="flight.id" />
      </el-col>
    </el-col>
    <el-col :span="access ? 22 : 18" class="flight-item">
      <flight-direction
        :id="flight.id"
        :bid="flight.bid"
        :day="flight['load-day']"
        @passport="openPassport"
      />
      <el-col
        :span="access ? 3 : 4"
        class="pointer"
        @click.native="openPassport"
      >
        <el-row>{{ getField(flight.auto, 'state_numbers') }}</el-row>
        <el-row>{{ getField(flight.auto, 'state_numbers_trailer') }}</el-row>
      </el-col>
      <el-col
        :span="access ? 5 : 7"
        class="org-driver pointer"
        @click.native="openPassport"
      >
        <el-row class="org">
          {{ getField(flight.auto, 'carrier_name') }}
        </el-row>
        <el-row>
          {{ getDriver(flight.driver) }} Тел.:
          {{ getField(flight.driver, 'phone') }}
        </el-row>
      </el-col>
      <el-col
        v-if="access"
        :span="3"
        class="pointer"
        @click.native="openPassport"
      >
        <template v-if="flight.bid.is_tudatka">
          {{ flight.price_from_storage_driver }}&nbsp;руб за рейс
        </template>
        <template v-else>
          <el-row v-if="flight.bid.type_code !== 'harvest'" class="price">
            {{ flight.price_from_storage_driver | getPrice }}
            <span v-if="flight.bid.type_code === 'harvest_or_delivery'">
              (П)
            </span>
          </el-row>
          <el-row v-if="flight.bid.type_code !== 'delivery'" class="price">
            {{ flight.price_from_field_driver | getPrice }}
            <span v-if="flight.bid.type_code === 'harvest_or_delivery'">
              (У)
            </span>
          </el-row>
          <el-row>
            <b>{{ getRound(flight.cost_amount, 1) }} руб</b>
          </el-row>
        </template>
      </el-col>
      <el-col :span="access ? 4 : 5">
        <flight-act :id="flight.id" @act="openAct" />
        <flight-ttn
          :id="flight.id"
          :ttn-status="flight['ttn-status']"
          @ttn="openTTN"
        />
      </el-col>
      <flight-payment
        v-if="access"
        :id="flight.id"
        :left="flight.payment_left"
        :highlight-comment="Boolean(flight.admin_comment)"
        @edit-comment="isCommentOpen = true"
      />
    </el-col>

    <ResponseCommentModal
      v-if="isCommentOpen"
      :response="flight"
      :is-visible="isCommentOpen"
      @comment="setComment"
      @close="isCommentOpen = false"
    />
  </el-row>
</template>

<script>
import FlightAct from './FlightAct'
import FlightDirection from './FlightDirection'
import FlightPayment from './FlightPayment'
import FlightTtn from './FlightTTN'
import ResponseCommentModal from '@/components/Modals/ResponseCommentModal.vue'

export default {
  name: 'FlightsItem',
  components: {
    FlightDirection,
    FlightAct,
    FlightTtn,
    FlightPayment,
    ResponseCommentModal,
  },
  props: {
    flight: {
      type: Object,
      default: () => {},
    },
    open: {
      type: Function,
      default: () => {},
    },
    close: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isCommentOpen: false,
    }
  },
  computed: {
    access() {
      return this.canAction('flightsAccess')
    },
  },
  methods: {
    getDriver(driver) {
      return driver && driver.fio ? this.shortFio(driver.fio) : 'Нет данных'
    },
    getField(data, field) {
      return data && data[field] ? data[field] : 'Нет данных'
    },
    openPassport(e) {
      if (e.target.dataset.path) {
        const { path } = e.target.dataset

        if (path !== '#') {
          this.$router.push(e.target.dataset.path)
        }
      } else {
        this.open(this.flight, 'pasportModal')
      }
    },
    openTTN() {
      this.open(this.flight, '', 'TTNMode', this.flight)
    },
    openAct() {
      this.open(this.flight, 'actModal')
    },
    setComment() {
      this.isCommentOpen = false
      this.$emit('comment')
    },
  },
}
</script>

<style lang="sass">
.flight-item
  min-height: 80px
  display: flex
  align-items: center
  background: #fff
  margin-top: 20px
  & > .el-col
    height: 100%
    font-size: 14px
    line-height: 22px
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column
    &.pointer
      cursor: pointer
    .el-checkbox__label
      display: none
    &.direction
      font-size: 12px
      align-items: unset
    &.org-driver
      font-size: 12px
      align-items: unset
      padding-left: 20px
      .org
        font-size: 18px
        color: #98A9BC
    .price
      font-size: 16px
    .el-loading-spinner
      margin-top: -10px
</style>
